var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper container-xxl p-0" },
    [
      _c("div", { staticClass: "content-header row" }),
      _c("div", { staticClass: "content-body" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.appid, function (item) {
              return _c(
                "div",
                { key: item, staticClass: "col-xl-4 col-lg-6 col-md-6" },
                [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-end mt-1",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "uom-heading" },
                              [
                                _c("h4", { staticClass: "fw-bolder" }, [
                                  _vm._v(_vm._s(item.platform)),
                                ]),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "warning", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEditModal(item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { variant: "danger", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteAppId(item.id)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "app-collapse",
                          { attrs: { accordion: "" } },
                          [
                            _c(
                              "app-collapse-item",
                              { attrs: { title: "View Detail" } },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("p", [
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v("App ID:"),
                                    ]),
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v(" " + _vm._s(item.appId)),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v("App Secret:"),
                                    ]),
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v(" " + _vm._s(item.appSecret)),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v("Page Name:"),
                                    ]),
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v(" " + _vm._s(item.pageName)),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v("Page Id:"),
                                    ]),
                                    _c("span", { staticClass: "fw-bolder" }, [
                                      _vm._v(" " + _vm._s(item.pageId)),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            }),
            _c("div", { staticClass: "col-xl-4 col-lg-6 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-body text-sm-end text-center ps-sm-0",
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-add-facebook",
                                modifiers: { "modal-add-facebook": true },
                              },
                            ],
                            staticClass:
                              "stretched-link text-nowrap add-new-uom",
                            attrs: { href: "javascript:void(0)" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "btn btn-primary mb-3" },
                              [_vm._v("Add Social Connection")]
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v("Add Social connection, if it does not exist"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          2
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-add-facebook",
            "ok-only": "",
            "ok-title": "Accept",
            centered: "",
            size: "lg",
            title: "Add New Social Connection",
            "hide-footer": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-body px-5 pb-5" },
            [
              _c("div", { staticClass: "text-center mb-4" }, [
                _c("h1", { staticClass: "uom-title" }, [
                  _vm._v("Add Social Connection"),
                ]),
              ]),
              _c("validation-observer", { ref: "Social" }, [
                _c(
                  "form",
                  {
                    staticClass: "row",
                    attrs: { id: "addUomForm", onsubmit: "return false" },
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        { staticClass: "form-label", attrs: { for: "pageId" } },
                        [_vm._v("Page Id")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pageId,
                            expression: "pageId",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "pageId",
                          name: "pageId",
                          placeholder: "Enter Page Id",
                        },
                        domProps: { value: _vm.pageId },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pageId = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "pageName" },
                        },
                        [_vm._v("Page Name")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pageName,
                            expression: "pageName",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "pageName",
                          name: "pageName",
                          placeholder: "Enter Page Name",
                        },
                        domProps: { value: _vm.pageName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pageName = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "userToken" },
                        },
                        [_vm._v("User Token")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userToken,
                            expression: "userToken",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "userToken",
                          name: "userToken",
                          placeholder: "Enter User Token",
                        },
                        domProps: { value: _vm.userToken },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.userToken = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "appSecret" },
                          },
                          [_vm._v("App Secret")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "appSecret",
                            vid: "appSecret",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appSecret,
                                        expression: "appSecret",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "appSecret",
                                      name: "appSecret",
                                      placeholder: "Enter App Secret",
                                    },
                                    domProps: { value: _vm.appSecret },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.appSecret = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "app_Id" },
                          },
                          [_vm._v("App Id")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "app_Id",
                            vid: "app_Id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.app_Id,
                                        expression: "app_Id",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "app_Id",
                                      name: "app_Id",
                                      placeholder: "Enter App Id",
                                    },
                                    domProps: { value: _vm.app_Id },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.app_Id = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "platform" },
                          },
                          [_vm._v("Platform")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "Platform",
                            vid: "platform",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-select", {
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "platform",
                                      options: _vm.platformOptions,
                                      placeholder: "Select a Platform",
                                    },
                                    model: {
                                      value: _vm.platform,
                                      callback: function ($$v) {
                                        _vm.platform = $$v
                                      },
                                      expression: "platform",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 text-center mt-2 d-flex justify-content-between",
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-primary me-1",
                            attrs: { type: "submit" },
                            on: { click: _vm.addAppId },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v("Add Social Connection"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit-facebook",
            centered: "",
            size: "lg",
            title: "Edit Social Connection",
            "hide-footer": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-body px-5 pb-5" },
            [
              _c("div", { staticClass: "text-center mb-4" }, [
                _c("h1", { staticClass: "uom-title" }, [
                  _vm._v("Edit Social Connection"),
                ]),
              ]),
              _c("validation-observer", { ref: "EditSocial" }, [
                _c(
                  "form",
                  {
                    staticClass: "row",
                    attrs: { id: "editForm" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.updateAppId($event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "editPageId" },
                        },
                        [_vm._v("Page Id")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editPageId,
                            expression: "editPageId",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "editPageId" },
                        domProps: { value: _vm.editPageId },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.editPageId = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "editPageName" },
                        },
                        [_vm._v("Page Name")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editPageName,
                            expression: "editPageName",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "editPageName" },
                        domProps: { value: _vm.editPageName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.editPageName = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "editUserToken" },
                        },
                        [_vm._v("User Token")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editUserToken,
                            expression: "editUserToken",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "editUserToken" },
                        domProps: { value: _vm.editUserToken },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.editUserToken = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "editAppSecret" },
                          },
                          [_vm._v("App Secret")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "appSecret",
                            vid: "appSecret",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editAppSecret,
                                        expression: "editAppSecret",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "editAppSecret",
                                    },
                                    domProps: { value: _vm.editAppSecret },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.editAppSecret = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "editAppId" },
                          },
                          [_vm._v("App Id")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "app_Id",
                            vid: "app_Id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editAppId,
                                        expression: "editAppId",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text", id: "editAppId" },
                                    domProps: { value: _vm.editAppId },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.editAppId = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: { for: "editPlatform" },
                          },
                          [_vm._v("Platform")]
                        ),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            name: "Platform",
                            vid: "platform",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-select", {
                                    staticClass: "form-control",
                                    attrs: {
                                      disabled: "",
                                      options: _vm.platformOptions,
                                    },
                                    model: {
                                      value: _vm.editPlatform,
                                      callback: function ($$v) {
                                        _vm.editPlatform = $$v
                                      },
                                      expression: "editPlatform",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 text-center mt-2" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "submit" },
                          },
                          [_vm._v("Update Connection")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }